import { toParagraphContent, toTextContent } from '@principle-theorem/editor';
import { DATE_WITH_YEAR } from '@principle-theorem/shared';
import * as moment from 'moment-timezone';

export class GeneralPracticeHelpers {
  static buildSampleContent(): ReturnType<typeof toParagraphContent>[] {
    const today = moment().format(DATE_WITH_YEAR);
    return [
      toParagraphContent([toTextContent('123 Smile Street')]),
      toParagraphContent([toTextContent('Melbourne VIC 3000')]),
      toParagraphContent([]),
      toParagraphContent([toTextContent(today)]),
      toParagraphContent([]),
      toParagraphContent([toTextContent('Mrs Jane Smith')]),
      toParagraphContent([toTextContent('45 Example Avenue')]),
      toParagraphContent([toTextContent('Richmond VIC 3121')]),
      toParagraphContent([]),
      toParagraphContent([toTextContent('Dear Mrs Smith,')]),
      toParagraphContent([]),
      toParagraphContent([
        toTextContent(
          'Re: Treatment Summary \u2014 Comprehensive Oral Examination'
        ),
      ]),
      toParagraphContent([]),
      toParagraphContent([
        toTextContent(
          'Thank you for attending your appointment on 28 March 2026. Following your comprehensive oral examination, I am writing to provide a summary of our findings and recommended treatment plan.'
        ),
      ]),
      toParagraphContent([]),
      toParagraphContent([
        toTextContent(
          'During the examination, we completed a full periodontal assessment, intraoral and extraoral soft tissue examination, and reviewed your updated radiographs. Overall, your oral health is in good condition, with a few areas that would benefit from attention.'
        ),
      ]),
      toParagraphContent([]),
      toParagraphContent([
        toTextContent(
          'We have recommended a course of preventive treatment including a professional clean and fluoride application, along with a review of the existing restoration on tooth 36. A detailed treatment plan with associated fees has been prepared and is available through your patient portal.'
        ),
      ]),
      toParagraphContent([]),
      toParagraphContent([
        toTextContent(
          'Please do not hesitate to contact our practice on (03) 9123 4567 if you have any questions or would like to schedule your next appointment.'
        ),
      ]),
      toParagraphContent([]),
      toParagraphContent([toTextContent('Kind regards,')]),
      toParagraphContent([]),
      toParagraphContent([toTextContent('Dr Joe Bloggs')]),
      toParagraphContent([toTextContent('BDSc (Melb)')]),
    ];
  }
}
